export default "__VITE_ASSET__CGy1mtLX__"